import { useEffect, useRef, useState } from 'react'
import Modal from './Modal'
import { pexios, toast, UserLabel } from '../../utils/functions';
import { history } from '../../utils/variables';
import Timer from './Timer';
import { useSelector } from 'react-redux';
import ImageZoom from './ImageZoom';
import { t } from 'i18next';
import VehicleCard from '../../assets/images/sample_images/car-cart.png';
import VehicleCardBack from '../../assets/images/sample_images/back-car-cart.png';
import GreenCart from '../../assets/images/sample_images/green-cart.png';
import Plate from '../../assets/images/register-samples/plate.png'
import FrontCar from '../../assets/images/register-samples/front.png'
import BackCar from '../../assets/images/register-samples/back.png'
import FrontLeftCar from '../../assets/images/register-samples/left-front.png'
import LeftCar from '../../assets/images/register-samples/left.png'
import BackLeftCar from '../../assets/images/register-samples/left-back.png'
import BackRightCar from '../../assets/images/register-samples/right-back.png'
import RightCar from '../../assets/images/register-samples/right.png'
import FrontRightCar from '../../assets/images/register-samples/right-front.png'
import CarCeiling from '../../assets/images/register-samples/roof.png'
import FrontGlass from '../../assets/images/register-samples/front-glass.png'
import BackGlass from '../../assets/images/register-samples/back-glass.png'
import Trunk from '../../assets/images/register-samples/truck.png'
import UnderTrunk from '../../assets/images/register-samples/under-trunck.png'
import Motor from '../../assets/images/register-samples/motor.png'
import PlateChassis from '../../assets/images/register-samples/chassis-plate.png'
import Chassis from '../../assets/images/register-samples/chassis.png'
import Cabin from '../../assets/images/register-samples/cabin.png'
import Kilometr from '../../assets/images/register-samples/km.png'
import Dashboard from '../../assets/images/register-samples/dashboard.png'
import RingFrontLeft from '../../assets/images/register-samples/left-front-ring.png'
import RingBackLeft from '../../assets/images/register-samples/left-back-ring.png'
import RingBackRight from '../../assets/images/register-samples/right-back-ring.png'
import RingFrontRight from '../../assets/images/register-samples/right-front-ring.png'
import IDCard from '../../assets/images/sample_images/id_card.jpg'
import LicenseImage from '../../assets/images/sample_images/license.png';
import BackLicenseImage from '../../assets/images/sample_images/back-license.png';
import ThirdImage from '../../assets/images/sample_images/third-image2.jpg';
import StopWatch from '../../assets/images/icons/stopwatch.png'

const ScreenCamera = ({imagesLabels, finishUpload, isRequired ,lossesIndex}) => {
    const videoRef = useRef(null);
    const [loader, setLoader] = useState(false);
    const [showPicture,setShowPicture] = useState('')
    const [notif,setNotif] = useState(true);
    const [imgIndex,setImgIndex] = useState(0);
    const [content, setContent] = useState('');
    const {type,id} = useSelector(store => store.routerData)
    const {accidentInfo} = useSelector(store => store)
    const [data,setData] = useState({images:[]})
    const user_type = accidentInfo.user_type || 'culprit'
    useEffect(() => {
        let close  
        // setContent('loader')
        setLoader(true)
        const startCamera = async () => {
            try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                close = setTimeout(()=>setNotif(false),3000)
                setContent('picker')
                setLoader(false)
            }
            } catch (error) {
                console.error("Error accessing the camera: ", error);
                toast('دسترسی به دوربین خود را فعال کنید','error');
            }
        };

        // camera && 
        startCamera();
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
            clearTimeout(close)
            }
        };
        }, []);
    useEffect(()=>{
        let timer
        if(content === 'picker'&& imagesLabels.length -1 !== imgIndex) {
            timer = setInterval(()=>{
                backgroundIImageCapturing()
                // setBgImgIndex(prevState => prevState + 1)
            },1000)
        }
        return()=>{
            clearInterval(timer)
        }
    },[content])
    function uploadDoc(image, name, done) {
            let { images } = data;
            let fd = new FormData();
            fd.append('id', id);
            fd.append('type',type);
            fd.append(name, image);
            pexios('api/upload_image','post', fd,true).then(res => {
                const index = images.findIndex(itm => itm.filename === name);
                if (index !== -1)
                    images[index] = res.data;
                else
                    images.push(res.data);
                setShowPicture(res.data.uid)
               setData({
                        images
                    });
                done();
            }).catch(err=>{
                console.log(err.response)
            });
    }
    function getImage(dataUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = dataUrl;
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (el, err) => {
                reject(err.error);
            };
        });
    }
    function imageName() {
        if(user_type === 'culprit') return `${user_type}_${ImagesData[imagesLabels[imgIndex]].name}`
        else return `${user_type}_${ImagesData[imagesLabels[imgIndex]].name}${lossesIndex}`
    }
    function createImage(image) {
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;
    
            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;
    
            let newWidth = oldWidth;
            let newHeight = oldHeight;
    
            // if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            // }
    
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
    
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                uploadDoc(blob,imageName(), () => {
                    setTimeout(() => setLoader(false), 500);
                });
            },'image/jpeg', 0.7);
        }
    }
    function backgroundIImageCapturing (){
        const image = videoRef.current;
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;
    
            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;
    
            let newWidth = oldWidth;
            let newHeight = oldHeight;
    
            // if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 400)
                    : Math.floor(oldWidth / oldHeight * 400);
                newWidth = longestDimension === 'width' ? 400 : newSize;
                newHeight = longestDimension === 'height' ? 400 : newSize;
            // }
    
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
    
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('type',`bg_${type}`);
                fd.append('image', blob);
                pexios('/api/upload_background_image','post', fd,true)
                // finishBackgroundImageUpload(blob,`image_${bgImgIndex}`);
            },'image/jpeg', 0.7);
        }
    }
    async function takePicture() {
        // setContent('loader');
        setLoader(true)
        const image = videoRef.current;
        image && createImage(image)
        // if (image) {
        //     const oldWidth = image.videoWidth;
        //     const oldHeight = image.videoHeight;
    
        //     const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
        //     const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;
    
        //     let newWidth = oldWidth;
        //     let newHeight = oldHeight;
    
        //     // if (currentRes > 1080) {
        //         const newSize = longestDimension === 'width'
        //             ? Math.floor(oldHeight / oldWidth * 1080)
        //             : Math.floor(oldWidth / oldHeight * 1080);
        //         newWidth = longestDimension === 'width' ? 1080 : newSize;
        //         newHeight = longestDimension === 'height' ? 1080 : newSize;
        //     // }
    
        //     const canvas = document.createElement('canvas');
        //     canvas.width = newWidth;
        //     canvas.height = newHeight;
    
        //     const ctx = canvas.getContext('2d');
        //     ctx.drawImage(image, 0, 0, newWidth, newHeight);
        //     canvas.toBlob((blob) => {
        //         uploadDoc(blob,()=>{
        //             if(user_type === 'culprit') return `${user_type}_${imagesLabels[imgIndex].name}`
        //             else return `${user_type}_${imagesLabels[imgIndex].name}${lossesIndex}`
        //         }, () => {
        //             setTimeout(() => setLoader(false), 500);
        //         });
        //     },'image/jpeg', 0.7);
        // }
    }
    function AcceptOrDeclineBtns(type){
        if(type === 'accept') {
            if (imagesLabels.length -1 === imgIndex) {
                pexios('/api/finish_image_progress','post',{id:id,type:`bg_accident`})
                .then(()=>{
                    finishUpload()
                })
            }
            else setImgIndex(prevState => prevState + 1)
        }
        setShowPicture('')
    }
    function ChangeImage(type){
        if (imagesLabels.length -1 === imgIndex && type === 'next') {
            pexios('/api/finish_image_progress','post',{id:id,type:`bg_accident`})
            .then(()=>{
                finishUpload()
            })
        }
        else if(type === 'next') setImgIndex(prevState =>prevState + 1)
        else if(type === 'prev' && imgIndex > 0) setImgIndex(prevState =>prevState - 1)
    }
    async function submitImage(e) {
        const [file] = e.target?.files || [];
        setContent('loader');
        if (file) {
            const url = window.URL.createObjectURL(file);
            const image = await getImage(url);
            const oldWidth = image.naturalWidth;
            const oldHeight = image.naturalHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                uploadDoc(blob,imageName(),() => {
                    setTimeout(() => setContent('picker'), 500);
                });
            },'image/jpeg', 0.7);
        }
    }
    const ImagesData = {
        'vehicle_card_image' : {name: 'vehicle_card_image',title:t('Vehicle card'),src: VehicleCard,gallery: type !== 'register'},
        'vehicle_card_back_image' : {name: 'vehicle_card_back_image',title:t('Vehicle card back'),src: VehicleCardBack,gallery: type !== 'register'},
        'green_card' : {name: 'green_card',title:t('Green card'),src: GreenCart,rotate:true},
        'expert_plate' : {name: 'expert_plate',title:t('Vehicle plate'),src: Plate},
        'front_image' : {name:  'front_image',title:t('Front vehicle'),src: FrontCar},
        'front_left_image' : {name: 'front_left_image',title:t('Front Left vehicle'),src: FrontLeftCar},
        'left_image' : {name:  'left_image',title:t('Left side vehicle'),src: LeftCar},
        'back_left_image' : {name: 'back_left_image',title:t('Back Left vehicle'),src: BackLeftCar},
        'back_image' : {name:  'back_image',title:t('Back vehicle'),src: BackCar},
        'back_right_image' : {name: 'back_right_image',title:t('Back Right vehicle'),src: BackRightCar},
        'right_image' : {name:  'right_image',title:t('Right side vehicle'),src: RightCar},
        'front_right_image' : {name: 'front_right_image',title:t('Front Right vehicle'),src: FrontRightCar},
        'car_roof' : {name: 'car_roof',title:t('Car ceiling'),src: CarCeiling},
        'front_glass' : {name: 'front_glass',title:t('Front glass'),src: FrontGlass},
        'back_glass' : {name: 'back_glass',title:t('Back glass'),src: BackGlass},
        'trunk' : {name: 'trunk',title:t('Trunk'),src: Trunk},
        'under_trunk' : {name:  'under_trunk',title:t('Under trunk'),src: UnderTrunk},
        'motor' : {name: 'motor',title:t('Motor image'),src: Motor},
        'plate_chassis' : {name: 'chassis_plate',title:t('Plate chassis'),src: PlateChassis},
        'chassis_number' : {name: 'chassis_number',title:t('Engraved chassis number'),src: Chassis},
        'cabin' : {name: 'cabin',title:t('Cabin'),src: Cabin},
        'dashboard' : {name: 'dashboard',title:t('Dashboard'),src: Dashboard},
        'kilometer' : {name: 'kilometer',title:t('Kilometr image'),src: Kilometr},
        'ring_front_left' : {name: 'ring_front_left',title:t('Ring Front Left'),src: RingFrontLeft},
        'ring_back_left' : {name: 'ring_back_left',title:t('Ring Back Left'),src: RingBackLeft},
        'ring_back_right' : {name: 'ring_back_right',title:t('Ring Back Right'),src: RingBackRight},
        'ring_front_right' : {name: 'ring_front_right',title:t('Ring Front Right'),src: RingFrontRight},
        'chassis_plate' : {name: 'chassis_plate',title : t('Engraved chassis plate'),src: PlateChassis},
        'id_card' : {name : 'national_cart_image',title :t('ID card'),src: IDCard,gallery: true},
        'license_image' : {name: 'license_image',title :t('License'),src: LicenseImage,gallery: true},
        'license_back_image' : {name: 'license_back_image',title :t('License back'),src: BackLicenseImage,gallery: true},
        'third_image' : {name:  'third_image',title :t('Third insurance'),src: ThirdImage,rotate: true,gallery: true},
        'body_image' : {name:  'body_image',title :t('Body insurance'),src: ThirdImage,rotate: true,gallery: true},
    }
  return (
    <div>
        <Modal visible={true}>
            { loader &&
                <Modal visible={loader}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                </Modal>
            }
            {showPicture &&
                <Modal visible={true}>
                    <div className='image-modal'>
                        <ImageZoom imgUid={showPicture}/>
                        <div className='d-flex accept-or-decline-btn'>
                            <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('reject')}><span className='fas fa-times'/></button>
                            <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('accept')}><span className='fas fa-check'/></button>
                        </div>
                    </div>
                </Modal>
            }
            {
            <div className='screen-camera'>
                <video ref={videoRef} autoPlay playsInline muted style={{ height: '100%'}}></video>
                {content === 'picker' &&
                <>
                    {notif &&
                    <div className='tuturial-notif'> 
                        <i className='fas fa-times' onClick={()=> setNotif(false)}/>
                            لطفا در بازه زمانی مشخص شده تصاویر درخواستی را بارگذاری نمایید 
                            {!isRequired &&<p className='text-center'>در صورت دردسترس نبودن هر تصویر دکمه بعدی را بزنید</p>}
                    </div>
                    }
                <div className='register-timer'>
                    <Timer seconds={600} onFinish={()=>history.push('/user-images')} />
                    <div className='timer-img'><img src={StopWatch} alt="timer"/></div>
                </div>
                
                <div key={ImagesData[imagesLabels[imgIndex]].title}>
                    <h5 className=' border-bottom image-title'> {ImagesData[imagesLabels[imgIndex]].title} {type === 'accident' && UserLabel(user_type)}</h5>
                    <img className={`sample-img ${ImagesData[imagesLabels[imgIndex]]?.rotate ? 'not-rotate':''}`} src={ImagesData[imagesLabels[imgIndex]].src} alt="sample"/>
                </div>
                
                <div className='d-flex justify-center align-items-center navigate-btns'>
                    <button className='capture-btn' onClick={takePicture}/>
                </div>
                {!isRequired && <label className='btn-ontrol next-btn' onClick={()=>ChangeImage('next')}>بعدی</label>}
                {!isRequired && imgIndex !== 0 && <label className='btn-ontrol prev-btn' onClick={()=>ChangeImage('prev')}>قبلی</label>}
                {ImagesData[imagesLabels[imgIndex]]?.gallery && 
                    <label className='gallery-btn'>
                        انتخاب از گالری
                        <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                    </label>
                }
                </>
                }
            </div>
            }
        </Modal>
    </div>
  )
}

export default ScreenCamera